<div class="app-container">
  <page-header [icon]="'far-file-invoice-dollar'" [title]="'saleExports'">
    <ng-container class="header-button">
      <modal-print-export
        [exportType]="'sale-exports'"
        (resultExport)="createExportSales($event)"
        [dataCyAttribute]="'add-inventory'"
      ></modal-print-export>
    </ng-container>
  </page-header>

  <section class="content">
    <div class="container-fluid ps-0 pe-0">
      <app-base-listing
        [listName]="'printSaleExports'"
        [query]="queryPrintSaleExports"
        [columns]="listingColumns"
        [selectedColumns]="listingColumns"
        [sortProp]="sortProp"
        [sortDir]="sortDir"
        (callAction)="callAction($event)"
      ></app-base-listing>
    </div>
  </section>
</div>
